import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt';
import { Agent } from '@propertypal/shared/src/types/agents';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Chevron from '../icons/Chevron';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { MidHeading, LinkText, Text } from '../typography';
import { Container, Icon, Row } from './BranchBox.style';
import ContactAgent from './ContactAgent';

interface Props {
  branch: Agent;
}

const BranchBox: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container>
      <MidHeading>{props.branch.organisationBranch}</MidHeading>

      <Row>
        <Icon>
          <FontAwesomeIcon icon={faMapMarkerAlt} color={theme.textDark} style={{ fontSize: 22 }} />
        </Icon>

        <Text>
          {props.branch.addressLine1}, {props.branch.addressLine2} <br /> {props.branch.town} {props.branch.postcode}
        </Text>
      </Row>

      {props.branch.officePhone && props.branch.officePhone.displayNumber && (
        <ContactAgent agent={props.branch} page="Agent Group Landing Page" location="Branch Box" />
      )}

      <Link href={props.branch.url}>
        <LinkText as="span" mt={15} style={{ display: 'block' }}>
          View Branch Details <Chevron size={12} />
        </LinkText>
      </Link>
    </Container>
  );
};

export default BranchBox;
